export default __webpack_public_path__ + "static/media/local-product-icon.05377563.svg";